module.exports = __webpack_public_path__ + "img/re_file_up.a553158f.png";